<template>
  <van-popup :show="show" @update:show="emit('update:show', $event)" round position="bottom" :style="{ height: '50%' }">
    <van-nav-bar :title="title" left-arrow @click-left="emit('update:show', false)" />
    <van-grid :column-num="3">
      <van-grid-item v-for="sig in signatures" :key="sig.id" @click="selectSignature(sig)">
        <van-button :type="currentId === sig.id ? 'primary' : 'default'" block>
          <template #default>
            <div class="time-signature-icon">{{ sig.icon }}</div>
            <div class="time-signature-text">{{ sig.label }}</div>
          </template>
        </van-button>
      </van-grid-item>
    </van-grid>
  </van-popup>
</template>

<script setup lang="ts">
import type { TimeSignatureOption } from './types'

defineProps<{
  show: boolean
  title: string
  /** 当前选中的拍号唯一 id（如 '3/4' 与 '3/8'  beats 相同但 id 不同） */
  currentId: string
  signatures: TimeSignatureOption[]
}>()

const emit = defineEmits<{
  'update:show': [value: boolean]
  'select': [value: TimeSignatureOption]
}>()

function selectSignature(signature: TimeSignatureOption) {
  emit('select', signature)
  emit('update:show', false)
}
</script>

<style scoped>
.time-signature-icon {
  font-size: 1.2em;
  margin-bottom: 4px;
}

.time-signature-text {
  font-size: 0.9em;
}
</style>
